
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.304","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.028.671h10c.481 0 .87.4.87.895v1.79H4.158v-1.79c0-.494.39-.895.87-.895z"}}),_c('path',{attrs:{"d":"M15.898 3.355H4.158A18.304 18.304 0 01.797 14.126a.686.686 0 00.1.945.655.655 0 00.151.093 22.46 22.46 0 008.981 1.612 22.455 22.455 0 008.98-1.61.679.679 0 00.252-1.038 18.298 18.298 0 01-3.362-10.773zm-8.479 8.053L6.79 16.6m5.846-5.192l.628 5.192"}})])])
          )
        }
      }
    